<template>
  <!--begin::Dashboard-->
  <!--  <div class="row">
      <div class="col-xxl-4">
        <MixedWidget1></MixedWidget1>
      </div>
      <div class="col-xxl-4">
        <ListWidget9></ListWidget9>
      </div>
      <div class="col-xxl-4">
        <StatsWidget7></StatsWidget7>
        <StatsWidget12></StatsWidget12>
      </div>

      <div class="col-xxl-4 order-1 order-xxl-1">
        <ListWidget1></ListWidget1>
      </div>
      <div class="col-xxl-8 order-2 order-xxl-1">
        <AdvancedTableWidget2></AdvancedTableWidget2>
      </div>

      <div class="col-xxl-4 order-1 order-xxl-2">
        <ListWidget3></ListWidget3>
      </div>
      <div class="col-xxl-4 order-1 order-xxl-2">
        <ListWidget4></ListWidget4>
      </div>
      <div class="col-lg-12 col-xxl-4 order-1 order-xxl-2">
        <ListWidget8></ListWidget8>
      </div>
    </div> -->
  <!--end::Dashboard-->
  <b-card class=" dashboard-i border p-0 h-100 mx-0">
    <div class=" py-5 my-3">
      <h1 class="card-title font-weight-bolder text-center mb-0">
        Ingresos del día
      </h1>
    </div>
    <apexchart
      class="card-rounded-bottom pb-5"
      :options="chartOptions"
      :series="seriesC"
      type="area"
    ></apexchart>
    <h4 class="d-flex justify-content-around mt-5">
      <span> <strong>Total: </strong>{{ total }}</span>
      <span style="color:#e15765">
        <strong>Faltantes: </strong>{{ faltantes }}
      </span>
      <span style="color:#27A745">
        <strong>Ingresos: </strong>{{ ingresos }}
      </span>
    </h4>
  </b-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
/*import AdvancedTableWidget2 from "@/view/content/widgets/advance-table/Widget2.vue";
import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
import ListWidget1 from "@/view/content/widgets/list/Widget1.vue";
import ListWidget3 from "@/view/content/widgets/list/Widget3.vue";
import ListWidget4 from "@/view/content/widgets/list/Widget4.vue";
import ListWidget8 from "@/view/content/widgets/list/Widget8.vue";
import ListWidget9 from "@/view/content/widgets/list/Widget9.vue";
import StatsWidget7 from "@/view/content/widgets/stats/Widget7.vue";
import StatsWidget12 from "@/view/content/widgets/stats/Widget12.vue";*/

export default {
  name: "dashboard",
  components: {
    /* AdvancedTable
   Widget2,
    MixedWidget1,
    ListWidget1,
    ListWidget3,
    ListWidget4,
    ListWidget8,
    ListWidget9,
    StatsWidget7,
    StatsWidget12 */
  },
  data: () => ({
    strokeColor: ["#e15765", "#27A745"],
    chartOptions: {},
    series: [
      {
        name: "Faltantes",
        data: [45]
      },
      {
        name: "Ingresos",
        data: [20]
      }
    ]
  }),
  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapState({
      users: state => state.users.users,
      getJornadaId: state => state.asistencias.jornadaId,
      asistencias: state => state.asistencias.asistencias,
      isAsistencias: state => state.asistencias.isAsistencias
    }),
    filterUsersRegisters() {
      //Obtiene asistencia  Pouchdb por Jornada Y area PREV. SELEC - mode ofline
      const usersReg = this.asistencias;
      const users = this.users;
      const filteredIds = [];
      usersReg.forEach(f => {
        if (f.jornadaId == this.getJornadaId) filteredIds.push(f.usuarioId);
      });
      const filtered = users.filter(user => filteredIds.includes(user.id));
      return filtered || [];
    },
    total() {
      return this.users.length;
    },
    ingresos() {
      return this.filterUsersRegisters.length;
    },
    faltantes() {
      return this.total - this.ingresos;
    },
    seriesC() {
      const ingresos = this.ingresos;
      const faltantes = this.faltantes;

      return [
        {
          name: "Faltantes",
          data: [faltantes]
        },
        {
          name: "Ingresos",
          data: [ingresos]
        }
      ];
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);

    this.chartOptions = {
      chart: {
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        sparkline: {
          enabled: true
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: undefined,
          top: 5,
          left: 0,
          blur: 3,
          color: [this.strokeColor],
          opacity: 0.5
        }
      },
      plotOptions: {},
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: "solid"
        // opacity: 0
      },
      stroke: {
        curve: "smooth",
        show: true,
        width: 3,
        colors: this.strokeColor
      },
      xaxis: {
        categories: ["Ingresados", "Faltantes"],
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        },
        crosshairs: {
          show: true,
          position: "front",
          stroke: {
            color: this.layoutConfig("colors.gray.gray-300"),
            width: 1,
            dashArray: 3
          }
        }
      },
      yaxis: {
        min: 0,
        // max: 200 ,
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0
          }
        },
        hover: {
          filter: {
            type: "none",
            value: 0
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0
          }
        }
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: this.layoutConfig("font-family")
        },
        /* y: {
              formatter: function(val) {
                return "$" + val + " thousands";
              }
            },*/
        marker: {
          show: true
        }
      },
      colors: this.strokeColor,
      markers: {
        colors: [this.layoutConfig("colors.theme.light.danger")],
        strokeColor: this.strokeColor,
        strokeWidth: 3
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0
        }
      }
    };
    //this.$store.dispatch("getAsistencias")
  },
  methods: {
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
    setChartOptions(total) {
      this.chartOptions = {
        chart: {
          type: "bar",
          height: 200,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          sparkline: {
            enabled: true
          },
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 5,
            left: 0,
            blur: 3,
            color: [this.strokeColor],
            opacity: 0.5
          }
        },
        plotOptions: {},
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: "solid"
          // opacity: 0
        },
        stroke: {
          curve: "smooth",
          show: true,
          width: 3,
          colors: this.strokeColor
        },
        xaxis: {
          categories: ["Ingresados", "Faltantes"],
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: true
          },
          labels: {
            show: true,
            style: {
              colors: this.layoutConfig("colors.gray.gray-500"),
              fontSize: "12px",
              fontFamily: this.layoutConfig("font-family")
            }
          },
          crosshairs: {
            show: true,
            position: "front",
            stroke: {
              color: this.layoutConfig("colors.gray.gray-300"),
              width: 1,
              dashArray: 3
            }
          }
        },
        yaxis: {
          min: 0,
          max: total,
          labels: {
            show: false,
            style: {
              colors: this.layoutConfig("colors.gray.gray-500"),
              fontSize: "12px",
              fontFamily: this.layoutConfig("font-family")
            }
          }
        },
        states: {
          normal: {
            filter: {
              type: "none",
              value: 0
            }
          },
          hover: {
            filter: {
              type: "none",
              value: 0
            }
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: "none",
              value: 0
            }
          }
        },
        tooltip: {
          style: {
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          },
          /* y: {
              formatter: function(val) {
                return "$" + val + " thousands";
              }
            },*/
          marker: {
            show: true
          }
        },
        colors: this.strokeColor,
        markers: {
          colors: [this.layoutConfig("colors.theme.light.danger")],
          strokeColor: this.strokeColor,
          strokeWidth: 3
        },
        grid: {
          show: false,
          padding: {
            left: 0,
            right: 0
          }
        }
      };
    }
  },
  watch: {
    /* total(nV){
       if(nV >= 0){
         this.setChartOptions(nV)
       }
     } */
  }
};
</script>

<style>
.dashboard-i .card-body {
  padding: 0;
}
</style>
